module.exports = __webpack_public_path__ + "static/media/autobookCollector.f9919eb0.svg";